export interface ReactTableProps {
  buttonCollapse?: string
  buttonExpand?: string
  id?: string
  isInEditor?: boolean
  isSecondary?: boolean
  tableId?: string
  text?: string
  top?: boolean
  right?: boolean
  bottom?: boolean
  left?: boolean
  lob?: string
  tableVariation: TableVariation
  headerTheme?: HeaderTheme
  alignment?: string
  tokenProperties?: string
}

export enum ComparisonTableVariation {
  PRIMARY = 'primary',
  SECONDARY = 'secondary'
}

export enum TableVariation {
  COMPARISON = 'comparison',
  MODAL = 'modal'
}

export enum HeaderTheme {
  DARK = 'dark',
  LIGHT = 'light'
}
